import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";
import { accentClass } from "@/utils/content";

export default function CategorySection() {
  return (
    <section id="categories" className="border-b border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="内容分类"
            title="按主题进入，更快找到你想看的那一类"
            desc="把假期里发生的事拆成五个主题方向，每个方向都保留独立的时间线与背景说明，方便你按兴趣深挖。"
            action={{ label: "查看全部盘点", href: "/topics" }}
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, index) => {
            const tone = accentClass[category.accent] ?? accentClass.primary;
            return (
              <Reveal key={category.slug} delay={index * 60}>
                <Link
                  to={`/topics?cat=${category.slug}`}
                  className="group flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
                >
                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-md border ${tone.bg} ${tone.border}`}
                  >
                    <i className={`${category.icon} text-xl ${tone.text}`} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                    {category.name}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                    进入分类
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                  </span>
                </Link>
              </Reveal>
            );
          })}

          <Reveal delay={categories.length * 60}>
            <div className="flex h-full flex-col justify-between rounded-lg border border-primary-800 bg-primary-950 p-5 md:p-6">
              <div>
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500">
                  <i className="ri-flashlight-line text-xl text-primary-950" />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-background-50">假期速报</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-200/85">
                  每天两次更新，把当天新增的讨论与澄清整理成一段话，订阅后第一时间收到。
                </p>
              </div>
              <Link
                to="/contact#subscribe"
                className="mt-4 inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-mail-send-line" />
                免费订阅
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}